<template>
  <!--<el-row>-->
  <!--<el-col :xs="24" :sm="24" :md="24" :lg="22" :xl="20">-->
  <div v-loading="loadingApplications">
    <!--finish-status="success"-->
    <div class="minifySteps">
      <el-steps
        :active="historyActive"
        process-status="process"
        align-center
        :direction="direction"
      >
        <el-step
          v-for="step in applicationSteps"
          :key="step.stepNumber"
          :title="step.action"
          :description="step.date"
          :icon="step.icon"
          :id="step.stepNumber"
          :ref="step.action"
          @click.native="e => stepClick(e, step.stepNumber)"
        >
        </el-step>
      </el-steps>
    </div>
    <div class="maxSteps">
      <el-steps
        :active="historyActive"
        process-status="process"
        align-center
        :direction="direction"
      >
        <el-step
          v-for="step in applicationSteps"
          :key="step.stepNumber"
          :title="step.action.substring(0, 6)"
          :description="step.date"
          :icon="step.icon"
          :id="step.stepNumber"
          :ref="step.action"
          @click.native="e => stepClick(e, step.stepNumber)"
        >
        </el-step>
      </el-steps>
    </div>
    <div style="text-align: center">
      <el-button
        style="margin-top: 5px; border-radius: 5px 20px; border: 2px solid #7fa3bb;"
        @click="previousHistoryStep"
        icon="el-icon-d-arrow-left"
      ></el-button>
      <el-button
        style="margin-top: 5px; border-radius: 20px 5px; border: 2px solid #7fa3bb;"
        @click="nextHistoryStep"
        icon="el-icon-d-arrow-right"
      ></el-button>
    </div>
    <el-card class="box-card user-apply-header">
      <div slot="header" class="clearfix">
        <span
          v-if="!finalized"
          v-show="applicationTempSaved ? historyActive == 0 : false"
        >
          {{ $t('app_process') }}
          <el-tooltip placement="right">
            <div slot="content">
              {{ $t('add_info') }}
            </div>
            <i class="el-icon-question"></i>
          </el-tooltip>
        </span>
        <span
          v-if="!finalized"
          v-show="
            applicationTempSaved ? historyActive == 1 : historyActive == 0
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_personal_data_with_caps') }}
        </span>
        <span
          v-if="!finalized"
          v-show="
          !isReappraisal && !isPostExam
          ? applicationTempSaved
            ? historyActive == 2 
            : historyActive == 1
          : false
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_information_title_of_study') }}
        </span>
        <span
          v-if="!finalized"
          v-show="
            application.consideration
              ? applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
              : false
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('fill_in_information_title_assesed') }}
        </span>
        <span
          v-show="!finalized"
          v-if="
          !isReappraisal && !isPostExam
            ? application.consideration
              ? applicationTempSaved
                ? historyActive == 4
                : historyActive == 3
              : applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
          : applicationTempSaved
            ? historyActive == 2
            : historyActive == 1
          "
        >
          <i class="el-icon-info"></i>
          {{ $t('upload_documents') }}
        </span>
        <span v-if="isReappraisal && isOverdue" style="color: red;">
          {{ $t('overdue_message') }}
        </span><br>
        <span
          style="padding: 3px 5px"
          v-show="application.praxeisNo !== null && finalized"
        >
          {{ $t('decision_no') }} :
          <b> {{ application.praxeisNo }} </b>
        </span>
        <span v-show='!isReappraisal && !isPostExam' style="padding: 3px 5px; color: grey">
          {{ $t('applicationType') }}: {{ $t(application.applicationType) }}
          {{
            application.correspondence
              ? $t('with_equivalence')
              : $t('without_equivalence')
          }}
          {{ $t('for') }}
          {{ $t(application.degreeType) }}
          {{
            application.degreeType === 'bachelor'
              ? application.consideration
                ? $t('with_consideration')
                : ''
              : ''
          }}
        </span>
         <span v-if='isReappraisal || isPostExam' style="padding: 3px 5px; color: grey">
          {{ $t('applicationType') }}: {{ $t(application.applicationType) }}
          {{ $t('for_app') }}
          {{ application.relevantAppl.id }}
        </span>
        <span v-if="finalized">
          <br />
          {{ $t('date_done') }}
          <b>{{ dateDone }}</b>
          {{ $t('date_received') }}
          <b>{{ dateReceived }}</b>
          <br />
          {{ $t('date_downloaded') }}
          <b>{{ dateDownloaded }}</b>
        </span>
      </div>
      <div class="text item" v-loading="saving">
        <div v-show="applicationTempSaved ? historyActive == 0 : false">
          <history-line :applicationHistory="history"></history-line>
        </div>
        <div
          v-show="
            applicationTempSaved ? historyActive == 1 : historyActive == 0
          "
        >
          <personal-details
            @personalDetailsChanged="personalDetailsEvent"
            :personalDetails="application.personalDetails"
            :applicationFinalSaved="applicationFinalSaved"
            :countries="countries"
            :checkFormPD="checkFormPD"
            @pdValidEvent="pdValidEvent"
          ></personal-details>
        </div>
        <div v-if="!isReappraisal && !isPostExam"
          v-show="
            applicationTempSaved ? historyActive == 2 : historyActive == 1
          "
        >
         <titles
            :application="application"
            @consider-other-titles="considerOtherTitlesEvent"
            :applicationFinalSaved="applicationFinalSaved"
            @titlesChanged="titlesChangedEvent"
            :isBachelor="isBachelor"
            :countries="countries"
            @countries="countriesEvent"
            :allDepartments="allDepartments"
            :academicAreasAll="academicAreasAll"
            @titlesCorrespondenceChanged="titlesCorrespondenceChangedEvent"
            :checkFormTitles="checkFormTitles"
            @titlesValidEvent="titlesValidEvent"
          >
          </titles>
          <!-- <titles
            :application="application"
            @consider-other-titles="considerOtherTitlesEvent"
            :applicationFinalSaved="applicationFinalSaved"
            @titlesChanged="titlesChangedEvent"
            :isBachelor="isBachelor"
            :countries="countries"
            @countries="countriesEvent"
            :greekUniversityDepartments="greekUniversityDepartments"
            :greekTeiDepartments="greekTeiDepartments"
            @titlesCorrespondenceChanged="titlesCorrespondenceChangedEvent"
            :checkFormTitles="checkFormTitles"
            @titlesValidEvent="titlesValidEvent"
          >
          </titles> -->
        </div>
        <div v-if="!isReappraisal && !isPostExam"
          v-show="
            application.consideration
              ? applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
              : false
          "
        >
          <title-consideration
            :titleConsideration="application.titles.titleConsideration"
            :application="application"
            :applicationFinalSaved="applicationFinalSaved"
            :countries="countries"
            @titleConsiderationChanged="titleConsiderationEvent"
            :consideration="application.consideration"
            :checkFormTC="checkFormTC"
            @considerationValidEvent="considerationValidEvent"
          >
          </title-consideration>
        </div>
        <div :applicationFinalSaved="applicationFinalSaved"
        v-show="
          isReappraisal || isPostExam
            ? applicationTempSaved
              ? historyActive == 2
              : historyActive == 1
            : application.consideration
              ? applicationTempSaved
                ? historyActive == 4
                : historyActive == 3
            : applicationTempSaved
                ? historyActive == 3
                : historyActive == 2
        "
        >

          <attached-documents
            :language="language"
            :applicationHistory="application.applicationHistory"
            :actApproval="actApprove"
            :precheckerCommentForUser="precheckerCommentForUser"
            :praksiDownloadedFromUser="praksiDownloadedFromUser"
            :attachedDocumentsTable="attachedDocumentsTable"
            :appId="application.id"
            :applicationFinalSaved="applicationFinalSaved"
            :neededDocsGr="neededDocsGr"
            :neededDocsEn="neededDocsEn"
            :neededDocsIds="neededDocsIds"
            :neededDocsInformation="neededDocsInformation"
            :neededDocsInformationGr="neededDocsInformationGr"
            :neededDocsInformationEng="neededDocsInformationEng"
            :neededDocsMandatory="neededDocsMandatory"
            :externalUserId="externalUserId"
            :appGeneralComment="application.userComment"
            @attachedDocumentsTableChanged="attachedDocumentsTableEvent"
            @documentsChanged="documentsChangedEvent"
            @generalCommentChanged="generalCommentChangedEvent"
            @mandatoryDocsEvent="mandatoryDocsM"
          >
          </attached-documents>
        </div>
        <div class="appStatus">
          <div>{{ $t('app_status') }}: {{ calcApplicationState }}</div>
          <!-- <div>{{ $t('app_ref') }}: {{ application.id }}</div> -->
          <div>{{ $t('reg_no') }}: {{ calcProtocol }}</div>
          <div v-if="isReappraisal">{{ $t('reappraisal_app') }}: {{ calcRelevantProtocol }}</div>
          <div v-if="isPostExam">{{ postExamRelevantAppText }}: {{ calcRelevantProtocol }}</div>
          <div v-if="isSecondReappraisal">{{ $t('first_reappraisal_app') }}: {{ application.relevantReappraisalAppl.protocol }}</div>
          <hr>
          <div>{{ $t('total_num_of_apps_are') }}: {{ usersAllApplications.length}} </div>
        </div>
      </div>
      <div style="text-align: center">
        <el-checkbox
          v-if="stagingEnv && application.applicationType === 'reappraisal' && !applicationFinalSaved && beforeFirstSave"
          style="margin-right: 20px;"
          v-model="forceOverdue"
        >
          {{ $t('force_overdue') }}
        </el-checkbox>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_tempsave') }}</div>
          <el-button
            size="mini"
            type="primary"
            round=""
            @click="tempSave"
            :disabled="applicationFinalSaved"
            >{{ $t('temp_save') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_finalsave') }}</div>
          <el-button
            size="mini"
            type="warning"
            round=""
            @click="finalSave"
            :disabled="applicationFinalSaved"
            >{{ $t('final_save') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_delete') }}</div>
          <el-button
            size="mini"
            type="danger"
            plain="plain"
            round=""
            @click="deleteApplication"
            :disabled="applicationFinalSaved"
            >{{ $t('delete_app') }}</el-button
          >
        </el-tooltip>
        <el-tooltip placement="top">
          <div slot="content">{{ $t('hint_retract') }}</div>
          <el-button
            size="mini"
            type="danger"
            plain="plain"
            round=""
            @click="retractApplication"
            :disabled="!(applicationFinalSaved && inPrecheckersQueue)"
            >{{ $t('retract_app') }}</el-button
          >
        </el-tooltip>
      </div>
    </el-card>
  </div>
  <!--</el-col>-->
  <!--</el-row>-->
</template>

<script>
import axios from 'axios'
import PersonalDetails from './common/PersonalDetails'
import Titles from './common/Titles'
import TitleConsideration from './common/TitleConsideration'
import AttachedDocuments from './common/AttachedDocuments'
import HistoryLine from './common/HistoryLine'
import config from '../config.js'
import sharedMethods from './common/sharedMethods.js'
// import { DataSet } from "vue2vis";

const decisionReceiptDocs = [20, 1008, 1010]

export default {
  name: 'userApply',
  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav)
    this.$once("hook:beforeDestroy", () => {
      window.removeEventListener("beforeunload", this.preventNav);
    })
  },
  beforeRouteEnter(to, from, next) {
    if (to.fullPath === '/userApply' && from.fullPath === '/') {
      next(vm => {
        let obj = JSON.parse(sessionStorage.getItem('workingApplication'))
        this.isOverdue = obj.overdue
        vm.$emit('workingApplication', obj)
      })
    }
    next()
  },
  mounted: function() {
    this.application = JSON.parse(sessionStorage.getItem('workingApplication'))
    this.localHistory = this.history
    // Initialize new fields if they don't exist
    if (!this.application.titlesCorrespondence.fieldOfStudy) {
      this.application.titlesCorrespondence.fieldOfStudy = { id: null, name: null }
    }
    if (!this.application.titlesCorrespondence.titleProgramme) {
      this.application.titlesCorrespondence.titleProgramme = { id: null, name: null }
    }
    if (!this.application.titlesCorrespondence.specialization) {
      this.application.titlesCorrespondence.specialization = { id: null, name: null }
    }
    if (!this.application.titlesCorrespondence.subSpecialization) {
      this.application.titlesCorrespondence.subSpecialization = { id: null, name: null }
    }
    if (JSON.parse(sessionStorage.getItem('refreshed'))) {
      this.$notify.warning({
        title: this.$t('warning'),
        message: this.$t('refresh_notallowed'),
        duration: 0,
        offset: 100,
      })
      let app = JSON.parse(sessionStorage.getItem('workingApplication'))
      this.isOverdue = app.overdue
      this.$emit('workingApplication', app)
      this.$emit(
        'neededDocsGr',
        JSON.parse(sessionStorage.getItem('neededDocsGr'))
      )
      this.$emit(
        'neededDocsEn',
        JSON.parse(sessionStorage.getItem('neededDocsEn'))
      )
      this.$emit(
        'neededDocsIds',
        JSON.parse(sessionStorage.getItem('neededDocsIds'))
      )
      this.$emit(
        'neededDocsInformation',
        JSON.parse(sessionStorage.getItem('neededDocsInformation'))
      )
      this.$emit(
        'neededDocsInformationGr',
        JSON.parse(sessionStorage.getItem('neededDocsInformationGr'))
      )
      this.$emit(
        'neededDocsInformationEng',
        JSON.parse(sessionStorage.getItem('neededDocsInformationEng'))
      )
      this.$emit(
        'neededDocsMandatory',
        JSON.parse(sessionStorage.getItem('neededDocsMandatory'))
      )
      this.$emit(
        'userLoggedIn',
        JSON.parse(sessionStorage.getItem('currentUser'))
      )
      this.$emit(
        'externalUserId',
        JSON.parse(sessionStorage.getItem('externalUserId'))
      )
      this.$emit(
        'usersAllApplications',
        JSON.parse(sessionStorage.getItem('usersAllApplications'))
      )
      this.$emit('countries', JSON.parse(sessionStorage.getItem('countries')))
      sessionStorage.setItem('refreshed', false)
    }
    axios
      .get(
        `${config.BASE_URL}/greekInstitutions`
      )
      .then(response => {
        this.allDepartments = response.data.data
		    // console.log('this.allDepartment', this.allDepartments)
        // this.$emit(
        //   'greekUniversityDepartments',
        //    this.allDepartments
        // )
        // // this.$emit('greekTeiDepartments', this.greekTeiDepartments)
      })
      .catch(err => {
        this.backendErrorNotify(err)
      })
    axios
      .get(`${config.BASE_URL}/new_academic_areas_all`)
      .then((response) => {
        this.academicAreasAll = response.data.data
        console.log('academicAreasAll loaded', this.academicAreasAll)
      })
      .catch((err) => {
        console.error('Error loading academic areas:', err)
        this.$message.error(this.$t('loadAcademicAreasErrorMsg'))
      })
  },
  components: {
    PersonalDetails,
    Titles,
    HistoryLine,
    TitleConsideration,
    AttachedDocuments,
  },
  props: [
    'application',
    'externalUserId',
    'fetchingNewApp',
    'countries',
    'neededDocsGr',
    'neededDocsEn',
    'neededDocsIds',
    'neededDocsInformation',
    'neededDocsInformationGr',
    'neededDocsInformationEng',
    'neededDocsMandatory',
  ],
  mixins: [sharedMethods],
  data() {
    return {
      stagingEnv: config.STAGING_ENV,
      forceOverdue: false,
      beforeFirstSave: false,
      isOverdue: false,
      minimizedGreekDepts: [],
      allDepartments: [],
      academicAreasAll: [],
      localHistory: [{ content: this.$t('loadingStatusMsg') }],
      precheckerCommentForUser: '',
      direction: 'horizontal',
      greekTeiDepartments: [],
      greekUniversityDepartments: [],
      externalUser: {},
      pilotNewEdit: 'new',
      transition: 'transition',
      consideration: 'consideration',
      correspondence: 'correspondence',
      // language: '',
      informed: false,
      applicationFinalSaved: this.application.applicationHistory
        ? this.application.applicationHistory[
            this.application.applicationHistory.length - 1
          ].applicationStatus !== 'userW_'
        : false,
      applicationTemp: {},
      usersAllApplications: JSON.parse(sessionStorage.getItem('usersAllApplications')),
      loadingApplication: false,
      historyActive: 0,
      saving: false,
      pdValid: false,
      titlesValid: false,
      considerationValid: false,
      checkFormPD: false,
      checkFormTitles: false,
      checkFormTC: false,
      mandatoryDocs: false,
    }
  },
  methods: {
    preventNav(event) {
      // if (!this.isEditing) return
      let obj = JSON.parse(sessionStorage.getItem('workingApplication'))
      this.isOverdue = obj.overdue
      this.$emit('workingApplication', obj)
      event.preventDefault()
      event.returnValue = ""
    },
    attachedDocumentsTableEvent(table) {
      this.application.attachedDocuments = table
    },
    setPreCommentForUser(pendingReason) {
      this.precheckerCommentForUser = pendingReason
    },
    mandatoryDocsM(mandatory) {
      this.mandatoryDocs = mandatory
    },
    validateAllForms() {
      if (this.application.applicationType !== 'reappraisal') {
        if (this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
          this.checkFormTC = !this.checkFormTC
        } else if (!this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.applicationType === 'reappraisal') {
        this.checkFormPD = !this.checkFormPD
      }
    },
    activateValidation() {
      if (this.application.applicationType !== 'reappraisal') {
        if (this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
          this.checkFormTC = !this.checkFormTC
        } else if (!this.application.consideration) {
          this.checkFormPD = !this.checkFormPD
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.applicationType === 'reappraisal') {
        this.checkFormPD = !this.checkFormPD
      }
    },
    validateCurrentForm() {
      if (this.application.consideration && this.applicationTempSaved) {
        if (this.historyActive === 1) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 2) {
          this.checkFormTitles = !this.checkFormTitles
        }
        if (this.historyActive === 3) {
          this.checkFormTC = !this.checkFormTC
        }
      } else if (!this.application.consideration && this.applicationTempSaved) {
        if (this.historyActive === 1) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 2) {
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (
        !this.application.consideration &&
        !this.applicationTempSaved
      ) {
        if (this.historyActive === 0) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 1) {
          this.checkFormTitles = !this.checkFormTitles
        }
      } else if (this.application.consideration && !this.applicationTempSaved) {
        if (this.historyActive === 0) {
          this.checkFormPD = !this.checkFormPD
        }
        if (this.historyActive === 1) {
          this.checkFormTitles = !this.checkFormTitles
        }
        if (this.historyActive === 2) {
          this.checkFormTC = !this.checkFormTC
        }
      }
    },
    stepClick(e, i) {
      this.validateCurrentForm()
      this.historyActive = i
    },
    countriesEvent(countries) {
      this.countries = countries
    },
    titlesCorrespondenceChangedEvent(titles) {
      this.application.titlesCorrespondence = titles
    },
    transitionChanged(transition) {
      this.application.transition = transition === 'transition'
    },
    considerationChanged(consideration) {
      this.application.consideration = consideration === 'consideration'
    },
    correspondenceChanged(correspondence) {
      this.application.correspondence = correspondence === 'correspondence'
    },
    // considerOtherTitles () {
    //   this.$emit('consider-other-titles', this.application.consideration)
    //   this.$emit('titlesChanged', this.titles)
    // },
    // where is this function used?????
    notifyForDB() {
      this.$notify.warning({
        title: this.$t('Warning'),
        message: this.$t('msg_forDB'),
        offset: 100,
      })
    },
    retractApplication() {
      this.$confirm(this.$t('confirm_retract'), this.$t('warning'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(() => {
          this.saving = true
          axios
            .post(
              `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/retraction`
            )
            .then(response => {
              this.saving = false
              this.backendSuccessMsg(response)
              this.$emit('newApplication')
              this.$router.replace('/login')
            })
            .catch(err => {
              this.saving = false
              this.backendErrorNotify(err)
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('retract_canceled'),
          })
        })
    },
    deleteApplication() {
      this.$confirm(this.$t('confirm_delete'), this.$t('warning'), {
        confirmButtonText: 'OK',
        cancelButtonText: this.$t('cancel'),
        type: 'warning',
      })
        .then(() => {
          this.saving = true
          if (this.applicationFinalSaved) {
            alert('Cannot be deleted after Final Save')
          } else {
            axios
              .delete(
                `${config.BASE_URL}/applications/${this.application.id}`
              )
              .then(response => {
                this.saving = false
                this.backendSuccessMsg(response)
                // this.$message({
                //   type: 'success',
                //   message: this.$t("app_deleted")
                // })
                this.$emit('newApplication')
                this.$router.replace('/login')
              })
              .catch(err => {
                this.saving = false
                this.backendErrorNotify(err)
                // this.$notify.warning({
                //   title: this.$t("warning"),
                //   message: this.$t("delete_fail"),
                //   offset: 100
                // })
              })
          }
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: this.$t('delete_canceled'),
          })
        })
    },
    checkAdditionalUnis() {
      if (
        this.application.titles.additionalUniversities != null &&
        this.application.titles.additionalUniversities.length > 0
      ) {
        this.application.titles.additionalUniversities = this.application.titles.additionalUniversities.filter(
          uni => uni.university !== '' && uni.university !== null
        )
        if (this.application.titles.additionalUniversities.length === 0) {
          this.application.titles.studiesInMoreUniversities = false
        }
      } else {
        this.application.titles.studiesInMoreUniversities = false
      }
      if (this.application.titles.titleConsideration) {
        if (
          this.application.titles.titleConsideration.additionalUniversities !=
            null &&
          this.application.titles.titleConsideration.additionalUniversities
            .length > 0
        ) {
          this.application.titles.titleConsideration.additionalUniversities = this.application.titles.titleConsideration.additionalUniversities.filter(
            uni => uni.university !== '' && uni.university !== null
          )
          if (
            this.application.titles.titleConsideration.additionalUniversities
              .length === 0
          ) {
            this.application.titles.titleConsideration.studiesInMoreUniversities = false
          }
        } else {
          this.application.titles.titleConsideration.studiesInMoreUniversities = false
        }
      }
    },
    finalSave() {
      this.checkAdditionalUnis()
      this.activateValidation()
      this.$nextTick(() => {
        this.validateAllForms()
        this.$nextTick(() => {
          let msg = this.$t('submitApp')
          if (this.isReappraisal && (this.isOverdue || (this.stagingEnv && this.forceOverdue))) {
            msg = this.$t('overdue_warning_final')
          }
          if (this.formsValid) {
            this.$confirm(msg, this.$t('warning'), {
              confirmButtonText: 'OK',
              cancelButtonText: this.$t('cancel'),
              type: 'warning',
              customClass: 'message-box-relative',
            })
              .then(() => {
                this.saving = true
                let appForSave = Object.assign({}, this.application)
                appForSave.correspondence = true
                // fix for compatibility with older apps
                appForSave.recognitionWith = "aeiAndTei"
                appForSave.language = this.$i18n.locale
                delete appForSave.neededDocuments
                delete appForSave.applicationHistory
                appForSave.forceOverdue = this.stagingEnv && this.forceOverdue
                axios
                  .put(
                    `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/final`,
                    appForSave
                  )
                  .then(response => {
                    this.saving = false
                    this.backendSuccessMsg(response)
                    // this.$notify.success({
                    //   title: 'Ειδοποίηση',
                    //   message: this.$t("msg_finalsave"),
                    //   duration: 0,
                    //   offset: 100
                    // })
                    this.applicationFinalSaved = true
                    this.$emit('applicationFinalSavedEvent', this.application.id)
                    this.applicationTemp = this.application
                  })
                  .catch(err => {
                    this.saving = false
                    this.backendErrorNotify(err)
                  })
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: this.$t('finalsave_canceled'),
                })
              })
              .finally(() => {
                this.saving = false
              })
          } else {
            this.tempSave()
            this.$notify.warning({
              title: this.validationMessage.title,
              message: this.validationMessage.body,
              duration: 10000,
              offset: 100,
            })
          }
        })
      })
    },
    tempSave() {
      this.checkAdditionalUnis()
      this.saving = true
      let appForSave = Object.assign({}, this.application)
      appForSave.correspondence = true
      appForSave.language = this.$i18n.locale
      delete appForSave.neededDocuments
      delete appForSave.applicationHistory
      appForSave.forceOverdue = this.stagingEnv && this.forceOverdue
      // /fromintusers/externalusers/
      axios
        .put(
          `${config.BASE_URL}/externalusers/${this.externalUserId}/applications/${this.application.id}/temp`,
          appForSave
        )
        .then(response => {
          this.saving = false
          // this.$notify.warning({
          //   title: this.$t("warning"),
          //   message: this.$t("data_saved"),
          //   offset: 100
          // })
          this.$emit('applicationFinalSavedEvent', this.application.id)
          this.application = JSON.parse(sessionStorage.getItem('workingApplication'))
          this.applicationTemp = this.application
          this.backendSuccessMsg(response)
        })
        .catch(err => {
          this.saving = false
          this.backendErrorNotify(err)
        })
    },
    degreeLevelChanged(degree) {
      if (degree === 'master' || degree === 'phd') {
        this.application.consideration = false
        this.consideration = 'noConsideration'
        this.correspondence = 'equality'
        this.application.correspondence = false
      } else {
        this.application.consideration = true
        this.consideration = 'consideration'
        this.correspondence = 'correspondence'
        this.application.correspondence = true
      }
    },
    pdValidEvent(pdValid) {
      this.pdValid = pdValid
    },
    titlesValidEvent(titlesValid) {
      this.titlesValid = titlesValid
    },
    considerationValidEvent(considerationValid) {
      this.considerationValid = considerationValid
    },
    documentsChangedEvent(attachedDocuments) {
      this.application.attachedDocuments = attachedDocuments.map(doc => {
        return {
          id: doc.id,
          applicantComment: doc.applicantComment,
          type: doc.type,
          date: doc.date,
          precheckerChecked: doc.precheckerChecked,
          precheckerComment: doc.precheckerComment,
          name: doc.name,
        }
      })
    },
    generalCommentChangedEvent(generalComment) {
      this.application.userComment = generalComment
    },
    considerOtherTitlesEvent(consider) {
      this.application.consideration = consider
    },
    personalDetailsEvent(personalDetails) {
      this.application.personalDetails = personalDetails
    },
    titlesChangedEvent(titles) {
      this.application.titles = titles
    },
    titleConsiderationEvent(titleConsideration) {
      this.application.titles.titleConsideration = titleConsideration
    },
    nextHistoryStep() {
      // this.validateCurrentForm()
      this.historyActive >= this.historySteps - 1
        ? (this.historyActive = 0)
        : this.historyActive++
    },
    previousHistoryStep() {
      // this.validateCurrentForm()
      this.historyActive < 1
        ? (this.historyActive = this.historySteps - 1)
        : this.historyActive--
    },
    submitUpload() {
      this.$refs.upload.submit()
    },
    inDays(d1, d2) {
      // let t2 = d2.getTime()
      // let t1 = d1.getTime()
      return Math.abs(d2 - d1)
      // dateStr.replace(/-/g,'/')
      // return parseInt((d2 - d1) / (24 * 3600 * 1000))
    },
  },
  computed: {
    inPrecheckersQueue () {
      return this.application.applicationHistory[
              this.application.applicationHistory.length - 1
            ].applicationStatus === 'precheckersQueue'
    },
    language () {
      return this.$i18n.locale
    },
    calcApplicationState() {
      this.$notify.info({
        title: this.$t('app_status1'),
        message: this.localHistory[this.localHistory.length - 1].content,
        offset: 100,
      })
      const lastState =  this.application.applicationHistory[
          this.application.applicationHistory.length - 1
        ].applicationStatus
      if (lastState === 'deactivated') {
        return this.$i18n.t('completed1')
      } else if (this.finalized) {
        return this.$i18n.t('completed2')
      } else if (
        this.application.protocol &&
        this.application.protocol !== null &&
        this.application.protocol !== ''
      ) {
        let registered_text = this.$i18n.t('registered_app')
        if (this.isReappraisal) {
          registered_text = this.$i18n.t('registered_reapp')
        }
        if (this.isPostExam) {
          registered_text = this.$i18n.t('registered_post_exam')
        }
        return registered_text
      } else if (this.application.applicationHistory.length > 1 && lastState !== 'userW_') {
        return this.$i18n.t('final_saved')
      } else {
        return this.$i18n.t('temp_saved')
      }
    },
    calcProtocol() {
      if (
        this.application.protocol &&
        this.application.protocol !== null &&
        this.application.protocol !== ''
      ) {
        const newForm = this.formatProtocol({ protocol: this.application.protocol })
        return newForm
      } else {
        return this.$t('protocol_expected')
      }
    },
    calcRelevantProtocol() {
      const newForm = this.formatProtocol({
        number: this.application.relevantAppl.protocol,
        date: this.application.relevantAppl.protocol_date
      })
      return newForm
    },
    postExamRelevantAppText() {
      if (!this.isPostExam) {
        return '---'
      }
      const appType = this.application.relevantAppl.specialFields.applicationType
      if (appType === 'reappraisal') {
        return this.$i18n.t('post_exam_reapp_app')
      }
      return this.$i18n.t('reappraisal_app')
    },
    actApprove() {
      return this.application.attachedDocuments.find(doc => doc.type === 22) &&
        this.application.attachedDocuments.find(doc => doc.type === 22)
          .actApproval
        ? this.application.attachedDocuments.find(doc => doc.type === 22)
            .actApproval
        : { approved: null, dateApproved: null, comment: null }
    },
    praksiDownloadedFromUser() {
      const lastState = this.application.applicationHistory[
          this.application.applicationHistory.length - 1
        ]
      if (lastState.applicationStatus === 'president_finalized') {
        let dateComple = lastState.dateCompleted
        let dateNow = new Date()
        if (dateComple !== null) {
          dateComple = new Date(dateComple.replace(/-/g, '/'))
          let diff = 10 - Math.floor(0.5 + (dateNow - dateComple) / 86400000)
          return diff // μερες που απομενουν
        } else {
          return -100 // ο χρήστης δεν έχει κατεβάσει ακόμα το αρχείο
        }
      } else {
        return -1 // δεν εχει φτάσει το τελευταιο βήμα η αίτηση
      }
    },
    dateDone() {
      return this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ].dateGR
    },
    dateReceived() {
      return this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ].dateCompletedGR
    },
    dateDownloaded() {
      const allRecognitions = this.application.attachedDocuments
          .filter(doc => decisionReceiptDocs.includes(doc.type)) || null

      if (allRecognitions && allRecognitions.length > 0) {
        if (allRecognitions.at(-1).downloadedByUserAtGR) {
          return allRecognitions.at(-1).downloadedByUserAtGR
        } else {
          console.log('Δεν υπάρχει βεβαίωση παραλαβής της τελευταίας πράξης.')
        }
      }
      return '-'
    },
    finalized() {
      const lastState = this.application.applicationHistory[
        this.application.applicationHistory.length - 1
      ]
      return lastState.applicationStatus === 'president_finalized' &&
        lastState.dateCompleted !== null
    },
    formsValid() {
      if (!this.isReappraisal && !this.isPostExam) {
        if (this.application.consideration) {
          return this.titlesValid && this.pdValid && this.considerationValid && this.mandatoryDocs
        } else if (!this.application.consideration) {
          return this.titlesValid && this.pdValid && this.mandatoryDocs
        // if (this.application.consideration) {
        //   return this.titlesValid && this.pdValid && this.considerationValid && this.mandatoryDocs
        // } else if (!this.application.consideration) {
        //   return this.titlesValid && this.pdValid && this.mandatoryDocs
        }
      } else if (this.isReappraisal || this.isPostExam) {
          return this.pdValid && this.mandatoryDocs
        } 
    },
    validationMessage() {
      let valMessage = { title: '', body: '' }
      if (!this.formsValid) {
        valMessage.title = this.$t('failed_submit')
        valMessage.body = this.$t('failed_submit2')
        if (!this.isReappraisal && !this.isPostExam) {
          if (this.application.consideration) {
            if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
            if (this.titlesValid === false)
              valMessage.body += this.$t('failed_submit4')
            if (this.considerationValid === false)
              valMessage.body += this.$t('failed_submit5')
            if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
          } else if (!this.application.consideration) {
            if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
            if (this.titlesValid === false)
              valMessage.body += this.$t('failed_submit4')
            if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
          }
        } else if (this.isReappraisal || this.isPostExam) {
          if (this.pdValid === false)
              valMessage.body += this.$t('failed_submit3')
          if (this.mandatoryDocs === false)
              valMessage.body += this.$t('failed_submit6')
        }
        valMessage.body = valMessage.body.slice(0, -1) + '.'
        return valMessage
      }
    },
    loadingApplications() {
      return this.fetchingNewApp
    },
    history() {
      let calcHistoryLine = []
      this.setPreCommentForUser('')
      if (this.application.applicationHistory) {
        let groupTemp = 0
        let titleTemp = ''
        let contentTemp = ''
        // let endTemp = ''
        let historySteps = this.application.applicationHistory.slice(0)
        for (let step = 0; step < historySteps.length; step++) {
          switch (historySteps[step].applicationStatus) {
            case 'userW_':
              groupTemp = 0
              titleTemp = this.$t('titleTemp0')
              // titleTemp = `<div>Ο χρήστης ετοιμάζει την αίτηση του πριν</div>
              //               <div>την υποβάλει οριστικά για επεξεργασία</div>`
              contentTemp = this.$t('contentTemp0')
              break
            case 'precheckersQueue':
              groupTemp = 1
              titleTemp = this.$t('titleTemp1')
              contentTemp = this.$t('contentTemp1')
              break
            case 'precheckerW_':
              groupTemp = 2
              if (historySteps[step].judgment.pending) {
                this.setPreCommentForUser(
                  historySteps[step].judgment.pendingReason
                )
              }
              titleTemp = historySteps[step].judgment.pending
                ? `<h4>${this.$t('titleTemp22')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                : this.$t('titleTemp21')
              contentTemp = this.$t('contentTemp2')
              break
            case 'precheckerCompensatoryW_':
              groupTemp = 2
              titleTemp = this.$t('titleTemp2postExam')
              contentTemp = this.$t('contentTemp2postExam')
              break
            case 'presidentW_Prechecker':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp3')}</div>`
              contentTemp = this.$t('titleTemp3')
              break
            case 'proponentW_President':
              groupTemp = 4
              titleTemp =
                historySteps[step].judgment &&
                historySteps[step].judgment.pendingReason
                  ? `<h4>${this.$t('titleTemp4')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                  : this.$t('titleTemp41')
              // titleTemp = `<div>Επεξεργασία από τον Χειριστή</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'proponentW_Prechecker':
              groupTemp = 4
              titleTemp =
                historySteps[step].judgment &&
                historySteps[step].judgment.pendingReason
                  ? `<h4>${this.$t('titleTemp4')}</h4>
                  <div>
                    ${
                      historySteps[step].judgment.pendingReason != null
                        ? historySteps[step].judgment.pendingReason
                        : ''
                    }
                  </div>${this.$t('titleTemp2')}`
                  : this.$t('titleTemp41')
              // titleTemp = `<div>Επεξεργασία από τον Χειριστή</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'boardW_Proponent':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'boardW_Vice':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'boardW_President':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'proponentW_Board':
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'proponentW_Admin':
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'consultantW_Proponent':
              groupTemp = 6
              titleTemp = `<div>${this.$t('titleTemp6')}</div>`
              contentTemp = this.$t('titleTemp6')
              break
            case 'consultantW_President':
              groupTemp = 6
              titleTemp = `<div>${this.$t('titleTemp6')}</div>`
              contentTemp = this.$t('titleTemp6')
              break
            case 'boardW_Consultant':
              groupTemp = 5
              titleTemp = `<div>${this.$t('titleTemp5')}</div>`
              contentTemp = this.$t('titleTemp5')
              break
            case 'viewerW_Board':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'presidentW_Viewer':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
            case 'presidentW_Consultant':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
            case 'viceW_President':
              groupTemp = 7
              titleTemp = `<div>${this.$t('titleTemp7')}</div>`
              contentTemp = this.$t('titleTemp7')
              break
            case 'viceW_Prechecker':
              groupTemp = 7
              titleTemp = `<div>${this.$t('titleTemp7')}</div>`
              contentTemp = this.$t('titleTemp7')
              break
            case 'viewerW_Vice':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'viewerW_Proponent':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'viewerW_President':
              groupTemp = 9
              titleTemp = `<div>${this.$t('titleTemp9')}</div>`
              contentTemp = this.$t('titleTemp9')
              break
            case 'printDecisionW_President':
              groupTemp = 10
              titleTemp = `<div>${this.$t('historyTitlePrintDecisionsQueue')}</div>`
              contentTemp = this.$t('historyContentPrintDecisionsQueue')
              break
            case 'printDecisionW_':
              groupTemp = 10
              titleTemp = `<div>${this.$t('historyTitlePrintDecision')}</div>`
              contentTemp = this.$t('historyContentPrintDecision')
              break
            case 'presidentW_PrintDecision':
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp32')}</div>`
              contentTemp = this.$t('titleTemp32')
              break
            case 'president_finalized':
              groupTemp = 3
              titleTemp = this.$t('titleTemp34')
              contentTemp =
                historySteps[step].dateCompleted !== null
                  ? this.$t('contentTemp34')
                  : this.$t('contentTemp34')
              break
            // case 'reappraisalBoardW_Vice' :
            //   groupTemp = 11
            //   titleTemp = `<div>${this.$t('titleTemp11')}</div>`
            //   contentTemp = this.$t('titleTemp11')
            //   break
            case 'reappraisalBoardW_President' :
              groupTemp = 11
              titleTemp = `<div>${this.$t('titleTemp11')}</div>`
              contentTemp = this.$t('titleTemp11')
              break
            case 'proponentW_ReappraisalBoard' :
              groupTemp = 4
              titleTemp = `<div>${this.$t('titleTemp41')}</div>`
              contentTemp = this.$t('titleTemp41')
              break
            case 'academicDirectorW_Proponent' :
              groupTemp = 12
              titleTemp = `<div>${this.$t('titleTemp12')}</div>`
              contentTemp = this.$t('titleTemp12')
              break
            case 'academicDirectorW_ReappraisalBoard' :
              groupTemp = 12
              titleTemp = `<div>${this.$t('titleTemp12')}</div>`
              contentTemp = this.$t('titleTemp12')
              break
            case 'presidentW_AcademicDirector_Reappraisal' :
              groupTemp = 3
              titleTemp = `<div>${this.$t('titleTemp33')}</div>`
              contentTemp = this.$t('titleTemp33')
              break
          }
          let d = historySteps[step].date
          // console.log(Date.parse(d.replace(/ /g,"T")))
          // console.log(typeof Date.parse(d.replace(/ /g,"T")))
          calcHistoryLine.push({
            id: historySteps[step].id,
            type: 'range',
            group: groupTemp, // null = 0
            content: contentTemp,
            start: Date.parse(historySteps[step].date),
            end:
              historySteps[step].dateCompleted !== null
                ? Date.parse(historySteps[step].dateCompleted)
                : Date.now(), // Date.now(),
            title: titleTemp,
          })
        }

        const allRecognitions = this.application.attachedDocuments
          .filter(doc => decisionReceiptDocs.includes(doc.type)) || null

        if (allRecognitions && allRecognitions.length > 0) {
          if (allRecognitions.at(-1).downloadedByUserAt) {
            calcHistoryLine.push({
              id: 'doc:' + allRecognitions.at(-1).id,
              group: 0,
              title: this.$t('historyTitleDownloaded'),
              start: allRecognitions.at(-1).downloadedByUserAt,
              content: this.$t('historyContentDownloaded')
            })
          } else {
            console.log('Δεν υπάρχει βεβαίωση παραλαβής της τελευταίας πράξης.')
          }
        }
      }
      return calcHistoryLine // new DataSet(calcHistoryLine)
    },
    conclusion() {
      let con = ''
      if (this.application.applicationType === 'recognition') {
        con = 'υποβάλετε Αίτηση Αναγνώρισης, '
        if (this.application.degreeType === 'bachelor') {
          con += 'για τίτλο 1ου κύκλου σπουδών,'
          if (this.application.correspondence) {
            con += ' με ακαδημαϊκή ισοδυναμία'
          } 
          // else {
          //   con +=
          //     ' απλής ισοτιμίας (χωρίς αντιστοίχιση τίτλου σε συγκεκριμένο Ελληνικό ιδρύμα)'
          // }
          // if (this.application.recognitionWith === 'aeiAndTei') {
          //   con += ' με Πανεπιστήμιο KAI ΤΕΙ'
          // } else if (this.application.recognitionWith === 'aei') {
          //   con += ' MONO με Πανεπιστήμιο'
          // } else if (this.application.recognitionWith === 'tei') {
          //   con += ' MONO με ΤΕΙ'
          // }
          // if (this.application.consideration) {
          //   con += ' δίνοντας επιπλέον τίτλο για συνεκτίμηση'
          // } else {
          //   con += ' ΧΩΡΙΣ επιπλέον τίτλο για συνεκτίμηση'
          // }
        } else if (this.application.degreeType === 'master') {
          con += 'για τίτλο 2ου κύκλου σπουδών'
          // if (this.application.scoreMatch) {
          //   con += ' με Βαθμολογική Αντιστοίχιση'
          // } else {
          //   con += ' χωρίς Βαθμολογική Αντιστοίχιση'
          // }
        } else if (this.application.degreeType === 'phd') {
          con += 'για τίτλο 3ου κύκλου σπουδών'
        }
      }
      return con
    },
    isBachelor() {
      return this.application.degreeType === 'bachelor'
    },
    isReappraisal() {
      return this.application.applicationType === 'reappraisal'
    },
    isPostExam() {
      return this.application.applicationType === 'compensatory'
    },
     isSecondReappraisal () {
      return this.application.reappraisalSecondDegree
    },
    applicationChanged() {
      return this.application !== this.applicationTemp
    },
    // τι νόημα έχει το applicationReady αφού πάντα είναι true όπως δηλώνεται εδώ???
    // applicationReady() {
    //   return true
    // },
    applicationTempSaved() {
      return !!(
        this.isPostExam || (this.application.id && this.application.applicationHistory.length > 1)
      )
    },
    applicationSteps() {
      if (!this.isReappraisal && !this.isPostExam) {
      let steps = [
        {
          stepNumber: 0,
          action: this.$t('process'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-search',
          details: 'axcdrefvevver',
        },
        {
          stepNumber: 1,
          action: this.$t('personal_data'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-info',
          details: 'rwfvraxcdrefvevver',
        },
        {
          stepNumber: 2,
          action: this.$t('title_study'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-edit',
          details: 'axfdvdfvcdrefvevver',
        },
        {
          stepNumber: 3,
          action: this.$t('coevaluation'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-edit-outline',
          details: 'axcdredfvdffvevver',
        },
        {
          stepNumber: 4,
          action: this.$t('attachments'),
          date: '',
          person: '',
          role: '',
          category: '',
          icon: 'el-icon-upload',
          details: 'axcdrefvevvedfvdfvr',
        },
      ]
      if (this.application.consideration && this.applicationTempSaved) {
        return steps
      } else if (!this.application.consideration && this.applicationTempSaved) {
        // steps.splice(3, 1)
        // let newSteps = steps.map(step => step.stepNumber = stepNumber++)
        return [
          {
            stepNumber: 0,
            action: this.$t('process'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-search',
            details: 'axcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 3,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      } else if (
        !this.application.consideration &&
        !this.applicationTempSaved
      ) {
        // steps.splice(0, 1)
        // steps.splice(2, 1)
        return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      } else if (this.application.consideration && !this.applicationTempSaved) {
        // steps.splice(0, 1)
        return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('title_study'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit',
            details: 'axfdvdfvcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('coevaluation'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-edit-outline',
            details: 'axcdredfvdffvevver',
          },
          {
            stepNumber: 3,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          },
        ]
      }
      } else if (this.isReappraisal || this.isPostExam) {
        if (this.applicationTempSaved) {
        return [
          {
            stepNumber: 0,
            action: this.$t('process'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-search',
            details: 'axcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 2,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          }
        ]
        } else if (!this.applicationTempSaved) {
           return [
          {
            stepNumber: 0,
            action: this.$t('personal_data'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-info',
            details: 'rwfvraxcdrefvevver',
          },
          {
            stepNumber: 1,
            action: this.$t('attachments'),
            date: '',
            person: '',
            role: '',
            category: '',
            icon: 'el-icon-upload',
            details: 'axcdrefvevvedfvdfvr',
          }
        ]
        }
      }
    },
    attachedDocumentsTable() {
      let table = []
      if (this.application.attachedDocuments) {
        this.application.attachedDocuments.slice(0).forEach(doc => {
          table.push({
            type: doc.type,
            typeGr: this.neededDocsGr[this.neededDocsIds.indexOf(doc.type)],
            typeEn: this.neededDocsEn[this.neededDocsIds.indexOf(doc.type)],
            name: doc.name,
            date: doc.date,
            applicantComment: doc.applicantComment,
            id: doc.id,
            precheckerChecked: doc.precheckerChecked,
            precheckerComment: doc.precheckerComment,
            downloadedByUserAt: doc.downloadedByUserAt
          })
        })
      }
      sessionStorage.setItem('attachedDocumentsTable', JSON.stringify(table))
      return table
    },
    historySteps() {
      return this.applicationSteps.length
    },
  },
  watch: {
    history: {
      handler: function(newData) {
        this.localHistory = newData
      },
      deep: true,
    },
    application: {
      handler: function(newData, oldData) {
        sessionStorage.setItem('workingApplication', JSON.stringify(newData))
        if (newData.id !== oldData.id) {
          this.historyActive = 0
        }
        this.applicationFinalSaved = this.application.applicationHistory
          ? this.application.applicationHistory[
              this.application.applicationHistory.length - 1
            ].applicationStatus !== 'userW_'
          : false
        // beforeFirstSave set
        const history = this.application.applicationHistory
        if (history) {
          if (history.length <= 1) {
            this.beforeFirstSave = true
          } else {
            this.beforeFirstSave = history[history.length - 2].user.id === null
          }
        } else {
          this.beforeFirstSave = false
        }
        if (this.stagingEnv && this.application.applicationType === 'reappraisal' && !this.applicationFinalSaved && this.beforeFirstSave) {
          this.forceOverdue = newData.overdue
        } else {
          this.forceOverdue = false
        }
        this.isOverdue = this.application.overdue
      },
      deep: true,
    },
    // formsValid: function () {
    // }
  },
}
</script>

<style lang="scss">
@import '../styles/variables.scss';
div.el-message-box.message-box-relative {
  width: 90%;
}
@media only screen and (max-width: $screen-sm-min) {
  .minifySteps {
    display: none;
  }
   div.el-message-box {
    width: 50%;
  }
}
@media only screen and (min-width: $screen-sm-min) {
  .maxSteps {
    display: none;
  }
  div.el-message-box.message-box-relative {
    width: 50%;
  }
}

.appStatus {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 5px;
  margin: 5px;
}
.el-card .box-card .user-apply-header {
  &.el-card__header {
    border-bottom: 0px;
  }
}
.el-card__header {
  border-bottom: 0px;
}
.el-input.is-disabled .el-input__inner {
  background-color: #f5f7fa;
  border-color: #e4e7ed;
  color: #8595be;
  cursor: not-allowed;
}
.el-radio__input.is-disabled + span.el-radio__label {
  color: #8595be;
  cursor: not-allowed;
}
.el-checkbox__input.is-disabled + span.el-checkbox__label {
  color: #8595be;
  cursor: not-allowed;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 190px;
}
/*button.el-button {*/
/*border-radius: 15px 30px;*/
/*border: 2px solid #7fa3bb;*/
/*}*/
// .big {
//   > .el-input {
//     width: 300px
//   }
// }
.el-dialog {
  border-radius: 25px;
  /*> .el-dialog--center {*/
  /*margin-top: 1vh;*/
  /*}*/
}
.el-row {
  display: flex;
  justify-content: center;
  margin-bottom: 60px;
}
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 178px;
}
.el-steps {
  border-radius: 5px 20px;
  border: 2px solid #7fa3bb;
  padding: 10px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 5px;
}
</style>
